import { render } from "./RecordCount.vue?vue&type=template&id=7b57b0d6"
import script from "./RecordCount.vue?vue&type=script&lang=js"
export * from "./RecordCount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Prefeitura\\Documents\\RadSystems\\TypeRad Projects\\cis\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__